"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var InputAmount_1 = __importDefault(require("../../InputAmount"));
var SubmitButton_1 = __importDefault(require("../SubmitButton"));
var TotalInfo_1 = __importDefault(require("../TotalInfo"));
var WithdrawalIsAccept_1 = __importDefault(require("../WithdrawalIsAccept"));
var WithdrawalIsCheck_1 = __importDefault(require("../WithdrawalIsCheck"));
var Cards_1 = __importDefault(require("./Cards"));
var Crypto_1 = __importDefault(require("./Crypto"));
var Transfer_1 = __importDefault(require("./Transfer"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useInitialValues_1 = require("./useInitialValues");
var useValidationSchema_1 = require("./useValidationSchema");
var accountTypes = [
    { value: 'IBAN', label: 'IBAN' },
    { value: 'Account number', label: 'Account number' },
];
var Methods = function (_a) {
    var _b;
    var balance = _a.balance, method = _a.method, canWithdraw = _a.canWithdraw, _c = _a.footerInsideInfo, footerInsideInfo = _c === void 0 ? false : _c;
    var t = (0, next_intl_1.useTranslations)('translation');
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var config = (0, swr_hooks_1.useConfig)();
    var countries = (0, swr_hooks_1.useCountriesOptions)();
    var _d = (0, react_1.useState)(null), cryptoCurrency = _d[0], setCryptoCurrency = _d[1];
    var _e = (0, react_1.useState)(null), cryptoNetwork = _e[0], setCryptoNetwork = _e[1];
    var currentCurrency = balance === null || balance === void 0 ? void 0 : balance.currency;
    var currencySettings = (0, react_1.useMemo)(function () {
        var _a;
        return (_a = method === null || method === void 0 ? void 0 : method.currencies) === null || _a === void 0 ? void 0 : _a.find(function (currency) { return currency.name === currentCurrency; });
    }, [method, currentCurrency]);
    var _f = (0, react_1.useState)(false), isOpenModalCheck = _f[0], setIsOpenModalCheck = _f[1];
    var _g = (0, react_1.useState)(false), isOpenModalAccept = _g[0], setIsOpenModalAccept = _g[1];
    // const openWithdrawalAccepted = useOpenWithdrawalAccepted()
    var _h = (0, swr_hooks_1.useMakeWithdrawal)({
        successAction: function () {
            setIsOpenModalAccept(true);
        },
    }), makeWithdrawal = _h.makeWithdrawal, isSubmitting = _h.isSubmitting;
    var initialValues = (0, useInitialValues_1.useInitialValues)({
        fields: __spreadArray(__spreadArray([], (((_b = config === null || config === void 0 ? void 0 : config.additionalWithdrawalFields) === null || _b === void 0 ? void 0 : _b[method === null || method === void 0 ? void 0 : method.name]) || []), true), method === null || method === void 0 ? void 0 : method.fields, true),
        min: currencySettings === null || currencySettings === void 0 ? void 0 : currencySettings.min,
        accountTypes: accountTypes,
    });
    var min = canWithdraw ? +((currencySettings === null || currencySettings === void 0 ? void 0 : currencySettings.min) || 0) : 0;
    var max = canWithdraw
        ? +((currencySettings === null || currencySettings === void 0 ? void 0 : currencySettings.max) || 0) > +(balance === null || balance === void 0 ? void 0 : balance.amount)
            ? balance === null || balance === void 0 ? void 0 : balance.amount
            : currencySettings === null || currencySettings === void 0 ? void 0 : currencySettings.max
        : 0;
    // 'Enter amount' + 'min max' if has and only 'min max' if has for mobile
    var amountPlaceholder = min > 0 && max > 0
        ? "".concat(!breakpoints.mobile && !breakpoints.tablet ? t('enterAmount') : '', " (").concat(t('min'), " ").concat((0, apps_shared_1.getCurrencySymbol)(currentCurrency)).concat(min, " - ").concat(t('max'), " ").concat((0, apps_shared_1.getCurrencySymbol)(currentCurrency)).concat(max, ")")
        : t('enterAmount');
    var validationSchema = (0, useValidationSchema_1.useValidateSchema)({
        fields: (method === null || method === void 0 ? void 0 : method.fields) || [],
        currencySymbol: (0, apps_shared_1.getCurrencySymbol)(currentCurrency),
        min: min,
        max: max,
    });
    var onSubmitHandler = (0, react_1.useCallback)(function (_a) {
        var _b;
        var amount = _a.amount, values = __rest(_a, ["amount"]);
        if (method) {
            makeWithdrawal(__assign(__assign({ amount: String(amount), paymentMethod: method.name }, values), { country: ((_b = values === null || values === void 0 ? void 0 : values.country) === null || _b === void 0 ? void 0 : _b.value) || undefined, coin: cryptoCurrency ? cryptoCurrency.value : '', networkType: cryptoNetwork ? cryptoNetwork.value : '', accountType: 'IBAN', accountOwner: values.firstName
                    ? "".concat(values.firstName, " ").concat(values.lastName)
                    : '' }));
        }
    }, [makeWithdrawal, method, cryptoCurrency, cryptoNetwork]);
    var showAdditionalFieldsInfo = (0, react_1.useCallback)(function (paymentType, values) {
        var _a, _b;
        return (_b = (_a = config === null || config === void 0 ? void 0 : config.additionalWithdrawalFields) === null || _a === void 0 ? void 0 : _a[paymentType]) === null || _b === void 0 ? void 0 : _b.map(function (item, idx) {
            var _a, _b;
            return !(item === null || item === void 0 ? void 0 : item.hidden) ? (react_1.default.createElement("div", { key: "withdrawalAdditionalField_".concat(item.type, "_").concat(idx) },
                react_1.default.createElement("span", null,
                    t(item.type),
                    ":"),
                react_1.default.createElement("b", null, item.type === 'phone'
                    ? "+".concat(values[item.type])
                    : item.type === 'country'
                        ? (_a = countries.find(function (country) { var _a; return country.value === ((_a = values[item.type]) === null || _a === void 0 ? void 0 : _a.value); })) === null || _a === void 0 ? void 0 : _a.label
                        : ((_b = values[item.type]) === null || _b === void 0 ? void 0 : _b.value) || values[item.type]))) : null;
        });
    }, [countries, t, config === null || config === void 0 ? void 0 : config.additionalWithdrawalFields]);
    var handleAmountOnChange = function (e, onChange) {
        // For prevent setting value < 0
        if (Number(e.target.value) < 0)
            e.target.value = 0;
        onChange(e);
    };
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.by },
            t('withdrawalBy'),
            " ",
            method.label),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.commission },
            t('limits'),
            " ",
            t('min'),
            " ",
            (0, apps_shared_1.getCurrencySymbol)(currentCurrency), currencySettings === null || currencySettings === void 0 ? void 0 :
            currencySettings.min,
            " \u2022 ",
            t('max'),
            ' ',
            (0, apps_shared_1.getCurrencySymbol)(currentCurrency), currencySettings === null || currencySettings === void 0 ? void 0 :
            currencySettings.max,
            "\u00A0\u00A0"),
        react_1.default.createElement(react_final_form_1.Form, { onSubmit: function () { return setIsOpenModalCheck(true); }, initialValues: initialValues, validate: validationSchema && (0, apps_shared_1.formValidator)(validationSchema), render: function (_a) {
                var handleSubmit = _a.handleSubmit, values = _a.values, form = _a.form;
                return (react_1.default.createElement("form", { onSubmit: handleSubmit },
                    react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.fields, " ").concat((method === null || method === void 0 ? void 0 : method.name) === 'crypto-currency' ? styles_module_scss_1.default.fieldsCrypto : '') },
                        (method === null || method === void 0 ? void 0 : method.name) === 'banking-card' && react_1.default.createElement(Cards_1.default, { method: method }),
                        (method === null || method === void 0 ? void 0 : method.name) === 'crypto-currency' && (react_1.default.createElement(Crypto_1.default, { currency: cryptoCurrency, setCurrency: setCryptoCurrency, network: cryptoNetwork, setNetwork: setCryptoNetwork, method: method })),
                        (method === null || method === void 0 ? void 0 : method.name) === 'bank-transfer' && react_1.default.createElement(Transfer_1.default, { method: method })),
                    react_1.default.createElement(react_final_form_1.Field, { name: "amount" }, function (_a) {
                        var input = _a.input, meta = _a.meta;
                        return (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement(InputAmount_1.default, __assign({ type: "number" }, input, { withClear: true, withMax: true, max: max, value: input.value, isDisabled: (method === null || method === void 0 ? void 0 : method.name) === 'crypto-currency' &&
                                    (!cryptoCurrency || !cryptoNetwork), placeholder: amountPlaceholder, onChange: function (e) { return handleAmountOnChange(e, input.onChange); }, errortext: meta.error && meta.touched
                                    ? { status: 'error', text: meta.error }
                                    : undefined }))));
                    }),
                    react_1.default.createElement(TotalInfo_1.default, { fee: 0, totalAmount: values.amount, currency: balance === null || balance === void 0 ? void 0 : balance.currency },
                        (method === null || method === void 0 ? void 0 : method.name) === 'crypto-currency' && (react_1.default.createElement("div", { className: styles_module_scss_1.default.info }, t('withdrawalCryptoInfo'))),
                        react_1.default.createElement(SubmitButton_1.default, { cryptoCurrency: cryptoCurrency, cryptoNetwork: cryptoNetwork, method: method, loading: isSubmitting, isEnabled: canWithdraw, amount: values.amount, balance: balance, currencySettings: currencySettings })),
                    isOpenModalCheck && (react_1.default.createElement(WithdrawalIsCheck_1.default, { methodName: method === null || method === void 0 ? void 0 : method.name, onClose: function () { return setIsOpenModalCheck(false); }, amount: "".concat((0, apps_shared_1.getCurrencySymbol)(currentCurrency)).concat(values.amount), onSubmit: function () { return onSubmitHandler(values); } },
                        (method === null || method === void 0 ? void 0 : method.name) === 'banking-card' && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null,
                                    t('toCard'),
                                    ":"),
                                react_1.default.createElement("b", null, values.cardNumber)),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null,
                                    t('cardExpirationDate'),
                                    ":"),
                                react_1.default.createElement("b", null, values.expirationDate)),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null,
                                    t('cardHolder'),
                                    ":"),
                                react_1.default.createElement("b", null,
                                    values.firstName,
                                    " ",
                                    values.lastName)),
                            showAdditionalFieldsInfo('banking-card', values))),
                        (method === null || method === void 0 ? void 0 : method.name) === 'crypto-currency' && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null,
                                    t('toAddress'),
                                    ":"),
                                react_1.default.createElement("b", null, formatCryptoAddress(values.cryptoAddress))),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null,
                                    t('cryptocurrency'),
                                    ":"),
                                react_1.default.createElement("b", null, cryptoCurrency === null || cryptoCurrency === void 0 ? void 0 : cryptoCurrency.value)),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null,
                                    t('network'),
                                    ":"),
                                react_1.default.createElement("b", null, cryptoNetwork === null || cryptoNetwork === void 0 ? void 0 : cryptoNetwork.value)),
                            showAdditionalFieldsInfo('crypto-currency', values))),
                        (method === null || method === void 0 ? void 0 : method.name) === 'bank-transfer' && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null, "To the bank account:"),
                                react_1.default.createElement("b", null, values.ibanAccountNumber)),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null, "Bank details:"),
                                react_1.default.createElement("b", null,
                                    values.bank,
                                    " ",
                                    react_1.default.createElement("br", null),
                                    " ",
                                    values.bicSwift,
                                    " ",
                                    react_1.default.createElement("br", null),
                                    ' ',
                                    values.bankAddress)),
                            showAdditionalFieldsInfo('bank-transfer', values))))),
                    isOpenModalAccept && (react_1.default.createElement(WithdrawalIsAccept_1.default, { method: method === null || method === void 0 ? void 0 : method.name, onClose: function () {
                            setIsOpenModalAccept(false);
                            setCryptoCurrency(null);
                            setCryptoNetwork(null);
                            form.reset();
                            form.getRegisteredFields().map(function (f) { return form.resetFieldState(f); });
                        }, amount: "".concat((0, apps_shared_1.getCurrencySymbol)(currentCurrency)).concat(values.amount) },
                        (method === null || method === void 0 ? void 0 : method.name) === 'banking-card' && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null,
                                    t('toCard'),
                                    ":"),
                                react_1.default.createElement("b", null, values.cardNumber)),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null,
                                    t('cardExpirationDate'),
                                    ":"),
                                react_1.default.createElement("b", null, values.expirationDate)),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null,
                                    t('cardHolder'),
                                    ":"),
                                react_1.default.createElement("b", null,
                                    values.firstName,
                                    " ",
                                    values.lastName)),
                            showAdditionalFieldsInfo('banking-card', values))),
                        (method === null || method === void 0 ? void 0 : method.name) === 'crypto-currency' && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null,
                                    t('toAddress'),
                                    ":"),
                                react_1.default.createElement("b", null, formatCryptoAddress(values.cryptoAddress))),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null,
                                    t('cryptocurrency'),
                                    ":"),
                                react_1.default.createElement("b", null, cryptoCurrency === null || cryptoCurrency === void 0 ? void 0 : cryptoCurrency.value)),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null,
                                    t('network'),
                                    ":"),
                                react_1.default.createElement("b", null, cryptoNetwork === null || cryptoNetwork === void 0 ? void 0 : cryptoNetwork.value)),
                            showAdditionalFieldsInfo('crypto-currency', values))),
                        (method === null || method === void 0 ? void 0 : method.name) === 'bank-transfer' && (react_1.default.createElement(react_1.default.Fragment, null,
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null,
                                    t('toBankAccount'),
                                    ":"),
                                react_1.default.createElement("b", null, values.ibanAccountNumber)),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("span", null,
                                    t('bankDetails'),
                                    ":"),
                                react_1.default.createElement("b", null,
                                    values.bank,
                                    " ",
                                    react_1.default.createElement("br", null),
                                    " ",
                                    values.bicSwift,
                                    " ",
                                    react_1.default.createElement("br", null),
                                    ' ',
                                    values.bankAddress)),
                            showAdditionalFieldsInfo('bank-transfer', values)))))));
            } })));
};
var formatCryptoAddress = function (address) {
    if (address.length > 14) {
        return "".concat(address.slice(0, 7), "....").concat(address.slice(-7));
    }
    return address;
};
exports.default = Methods;
